import { Selections } from "../../../services/api";
import PlayAllButton from "../../../components/PlayAllButton/PlayAllButton";
import TitledCover from "./TitledCover";
import { selectionDateRange } from "./SelectionCard";

interface FeaturedSelectionProps {
  selection: Selections;
  onOpen: (selection: Selections) => void;
  onPlay: (selection: Selections) => void;
}

// "This week": the newest selection, big. Cover with the title on it (click to open),
// then dates, description and Play. Side by side on desktop, stacked on phones.
const FeaturedSelection = ({ selection, onOpen, onPlay }: FeaturedSelectionProps) => (
  <div className="featuredSelection">
    <button type="button" className="featuredSelection__cover" onClick={() => onOpen(selection)} aria-label={selection.title}>
      <TitledCover selection={selection} size={480} variant="large" />
    </button>
    <div className="featuredSelection__text">
      <p className="featuredSelection__date">{selectionDateRange(selection)}</p>
      {selection.description && <p className="featuredSelection__description">{selection.description}</p>}
      <PlayAllButton className="featuredSelection__play" label="Play" onClick={() => onPlay(selection)} />
    </div>
  </div>
);

export default FeaturedSelection;
